import React from 'react';
import { default as withRouter } from "../../components/WithRouter/withRouter";

import Registration, { RegistrationTypes } from '../Registration/Registration';
import Success from '../Success/Success';

import { triggerConversionEvent } from '../../utils/paymentHelpers';

class ImANonProfit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: "register"
    };
  }

  onSuccess = () => {
    this.setState({ mode: "success" }, () => {
      triggerConversionEvent('nonprofit');
    });
  }

  render() {
    return (
      <>
        {this.state.mode !== 'success' &&
          <>
            <h1 className={`marginTop100 marginBottom25 text-center`}>
              <span className="reciprocityGreenText">i</span>'m a non-profit<span className="reciprocityLightBlueText">.</span>
            </h1>
            <Registration type={RegistrationTypes.nonprofit} image={'/assets/reciprocity-nonprofit-logo.png'} submitText="Get in touch"
              buttonColor="#005B89"
              subText={
                <>
                  <p>
                    Reciprocity payments offer a simple, accessible way for homes, businesses, and
                    events to act on the Indigenous principles that shaped and were shaped by the lands and
                    waters we love and rely on. They are voluntary, ongoing contributions that move beyond
                    symbolic acknowledgment toward meaningful action and meaningful relationships.
                  </p>
                  <p>
                    Are you a church, a non-profit organization, a union or co-op? Lots of different people want to be a part of this. Let’s figure out what it might look like for you!
                  </p>
                </>
              }
              onSuccess={this.onSuccess}
            />
          </>
        }
        {this.state.mode === 'success' &&
          <Success type='other'></Success>
        }
      </>
    )
  }
}

export default withRouter(ImANonProfit);
